<div class="page-container">
  <div class="relative page-edge-cut">
    <div class="form-card">
      <form [formGroup]="form">

        <!-- Action for show notes -->       
        @if (srNumber && srInprgoressAwating && !loadingSrDetail) {
          <app-validation-message
            type="info"
            [content]="{
              title: 'SECTION_NOTES' | translate,
              message: 'SECTION_NOTES_DESCRIPTION' | translate
            }"
            [showbutton]="false"
            [buttonText]="'VIEW_NOTES' | translate"
            (onBtnClick)="showNotes = true"
          />
        }   

        <!-- Section: request -->
        <section>
          <h1 class="section-heading" translate="ATA_CARNET.NOC.TITLE"></h1>
          <p class="px-2" translate="ATA_CARNET.NOC.DESC"></p>
        </section>
        <!-- type of carnet  -->
        <section>
          <h1
            class="section-heading"
            translate="ATA_CARNET.NOC.CARNET_TYPE"
          ></h1>
          <div class="fields-container">
            <div class="field-control">
              <app-boolean
                [label]="'ATA_CARNET.NOC.CARNET_TYPE_LABEL' | translate"
                [control]="form.get('carnetType')!"
                [lovType]="lookupKey.ATA_CARNET_TYPE"
                [labelKey]="'Value'"
                [valueKey]="'Value'"
                (onSelectionChange)="carnetTypeChange($event)"
              />
            </div>
            <!-- [options]="carnetOptions" -->

            @if (form.get('carnetType')?.value == fieldValue.LOCAL
            || form.get('carnetType')?.value == fieldValue.LOCAL_AR) {
            <div class="field-control">
              <div class="field-control">
                <app-option-field
                  [control]="form.get('carnetNumber')"
                  [label]="'ATA_CARNET.REFUND.CARNET_NUMBER' | translate"
                  [options]="carnetNumberList"
                  [labelKey]="'Name'"
                  (onSelectionChange)="onCarnetChange($event)"
                  [loading]="loadingCarnetList"
                >
                </app-option-field>
              </div>

               @if(expiredCarnetMsg){
              <app-validation-message
                [type]="'error'"
                [content]="{
                  title: 'VALIDATION_MSG.ERROR' | translate,
                  message: 'VALIDATION_MSG.CARNET_EXPIRED' | translate
                }"
                [showbutton]="false"
              ></app-validation-message>
              }
              @if(technicalErrorMsg){
              <app-validation-message
                [type]="'error'"
                [content]="{
                  title: 'VALIDATION_MSG.ERROR' | translate,
                  message: 'TOAST_MESSAGES.TECHNICAL_ERROR' | translate
                }"
                [showbutton]="false"
              ></app-validation-message>
              }
              @if(copyCarnetErrorMsg){
              <app-validation-message
                [type]="'error'"
                [content]="{
                  title: 'VALIDATION_MSG.ERROR' | translate,
                  message: copyCarnetErrorMsg
                }"
                [showbutton]="false"
              ></app-validation-message>
              }
            </div>
            } @if (form.get('carnetType')?.value == fieldValue.FOREIGN
            || form.get('carnetType')?.value == fieldValue.FOREIGN_AR) {
            <div class="field-control">
              <app-text-field
                [label]="'ATA_CARNET.NOC.FOREIGN_CARNET_NO' | translate"
                [control]="form.get('foreignCarnetNumber')!"
              >
              </app-text-field>
            </div>
            }
          </div>
        </section>

        @if(loadingSrDetail){
          <app-skeleton-loader></app-skeleton-loader>
        }
        @if(!loadingSrDetail){
        <!-- Section: reason  -->
        @if(step >= 2){
          <section>
            <h1
              class="section-heading"
              translate="ATA_CARNET.NOC.REASON_TITLE"
            ></h1>
            <div class="fields-container">
              <div class="field-control">
                <app-option-field
                  [label]="'ATA_CARNET.NOC.REASON_LABEL' | translate"
                  [control]="form.get('letterType')!"
                  [lovType]="lookupKey.ATA_NOC_LETTER_TYPE"
                  [labelKey]="'Description'"
                  [valueKey]="'Description'"
                >
                </app-option-field>
              </div>
            </div>
          </section>
        
          <!-- Section: contact  -->
          <section>
            <h1
              class="section-heading"
              translate="ATA_CARNET.NOC.CONTACT_TITLE"
            ></h1>
            <p class="px-2" translate="ATA_CARNET.NOC.CONTACT_DESC"></p>
            <div class="fields-container">
              <div class="field-control">
                <app-text-field
                  [label]="'ATA_CARNET.NOC.FULL_NAME' | translate"
                  [control]="form.get('fullName')!"
                >
                </app-text-field>
              </div>
              <div class="field-control">
                <app-text-field
                  [label]="'ATA_CARNET.NOC.EMAIL' | translate"
                  [control]="form.get('email')!"
                  [validationMessages]="{
                    email: 'VALIDATION_MSG.VALID_EMAIL' | translate
                  }"
                >
                </app-text-field>
              </div>
              <div class="field-control">
                <app-mobile-number
                  [label]="'ATA_CARNET.NOC.MOBILE' | translate"
                  [control]="form.get('mobile')!"
                  [countryCodeControl]="form.get('countryCode')!"
                  [validationMessages]="{
                    mobile: 'VALIDATION_MSG.VALID_MOBILE_NUMBER' | translate,
                    uaeMobile: 'VALIDATION_MSG.UAE_MOBILE_NUMBER' | translate
                  }"
                />
              </div>
              <div class="field-control">
                <app-text-field
                  [label]="'ATA_CARNET.NOC.PHONE' | translate"
                  [control]="form.get('phone')!"
                  [validationMessages]="{
                    mobile: 'VALIDATION_MSG.VALID_MOBILE_NUMBER' | translate
                  }"
                >
                </app-text-field>
              </div>
            </div>
          </section>

          <!-- Upload documents -------->
          <section>
            <h1 class="section-heading">
              {{ "ATA_CARNET.NOC.UPLOAD_DOCUMENTS" | translate }}
            </h1>
            <div class="px-2 hidden">
                <p [innerHTML]="'DOCUMENT_NOTE' | translate"></p>
            </div>
            
            <div class="fields-container">
             @if(loadingDoc){
              <app-skeleton-loader [formLoader]="true" [noOfFields]="3"></app-skeleton-loader>
            }
            @if (srFolder && !loadingDoc) {
              @for (dt of srFolder.allowedDocumentTypes; track $index) {
                <div class="field-control">
                  <app-file
                    #fileCmp
                    [title]="lang == 'en' ? dt.nameEn : dt.nameAr"
                    [control]=""
                    [documentType]="dt.nameEn"
                    (folderMissing)="openFolder()"
                    (onUploadRemove)="handelFileEvent($event, dt.nameEn)"
                    [showAction]="showActions"
                    [folder]="srFolder"
                    [documentServiceType]="documentServiceType.ATA_CARNET"
                    [stampLocationRequirement]="dt?.stampLocationRequirement || 'NOT_APPLICABLE'"
                ></app-file>
              </div>
              }
              }

              <!--T & C    ═-->
              <div class="field-control">
                <label class="flex items-center gap-5 lg:gap-x-2 cursor-pointer relative">
                  <input
                    formControlName="agree"
                    type="checkbox"
                    class="peer form-checkbox h-6 w-6 text-dc-navy border-dc-navy accent-dc-navy rounded-none"
                  />
                  <span
                    class="h-6 w-6 font-sans text-white text-sm text-center pt-0.25 absolute bg-white border border-dc-navy peer-checked:bg-dc-navy"
                  >
                    <i class="fas fa-check"></i>
                  </span>
                  <span
                    class="text-sm text-dc-navy"
                    (click)="openTermsCondition()"
                    [innerHTML]="'ATA_CARNET.AGREEMENT' | translate"
                  ></span>
                </label>
                @if( form.get('agree')?.touched &&
                form.get('agree')?.hasError('required')){
                <div class="fields-error-container">
                  {{ "VALIDATION_MSG.FIELD_REQUIRED" | translate }}
                </div>
                }
              </div>
            </div>
          </section>

          <!-- section for payment method -->
          <section>
            <h1 class="section-heading">
              {{ "SECTION_PAYMENT_METHOD" | translate }}
            </h1>
            <div class="fields-container">
              <div class="field-control">
                <app-boolean
                  [label]="'PAYMENT_METHOD' | translate"
                  [control]="form.get('paymentMethod')!"
                  [lovType]="lookupKey.PAYMENT_METHOD"
                  [labelKey]="'Value'"                  
                  [valueKey]="'Value'"
                  (onSelectionChange)="onPaymentMethodChange($event)"
                />
              </div>
              @if ( noAdvancePaymentBalance) {
                <app-validation-message
                  [content]="{
                    title: 'ALERT.ERROR' | translate,
                    message: 'ALERT.NO_ADVANCE_PAYMENT_BALANCE' | translate
                  }"
                  type="error"
                />
              }
            </div>
          </section>
        }
         <!-- Error Message -->
          @if (errorMsg) {
          <app-validation-message
            [type]="'error'"
            [content]="{
              title: 'ALERT.ERROR' | translate,
              message: errorMsg
            }"
          >
          </app-validation-message>
          }
        <div class="btn-section buttons-group">
          @if(!formSubmitLoader && showActions){
          <app-button
            type="button"
            [classesName]="'btn-edge-cut btn-width-auto'"
            [label]="'BUTTONS.SUBMIT' | translate"
            (onBtnClick)="submit()"
          ></app-button>
          } @if(formSubmitLoader){
          <app-button
            type="button"
            classesName="btn-edge-cut btn-width-auto"
            [label]="'PLEASE_WAIT' | translate"
            [disabled]="true"
          ></app-button>
          }
        </div>
      }
      </form>
    </div>
  </div>
  <div>
    <app-service-progress
      [serviceName]="'ATA_CARNET.APPLY_FOR_NOC' | translate"
      [completePercentage]="formProgress"
    />
  </div>
</div>

@if (successModal) {
<app-sr-submit-success-modal
  [srNumber]="srNumber"
  (onClose)="closeSuccessModal()"
></app-sr-submit-success-modal>
}

@if(showNotes) {
  <app-notes [srNumber]="srNumber" [allowSubmit]="true" (onClose)="showNotes = false;"></app-notes>
}

